// extracted by mini-css-extract-plugin
export default {"container":"s3-z","heading":"t3-z","links":"u3-z","copy":"v3-z","subCopy":"w3-z","linksLeft":"x3-z","linksCenter":"y3-z","linksRight":"z3-z","link":"A3-z","onlyLink":"B3-z"};